<ng-content></ng-content>

@if (show) {
    <span *ngIf="show" class="ui-highlight__alert {{text ? behaviour : 'only-alert'}}">
        @if (behaviour !== 'only-alert' && text) {
            <span class="ui-highlight__text">{{ text }}</span>
        }

        <i class="fa fa-exclamation-circle"></i>
    </span>
}

